/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./pc-footer.vue?vue&type=template&id=6125f398&scoped=true"
import script from "./pc-footer.vue?vue&type=script&lang=js"
export * from "./pc-footer.vue?vue&type=script&lang=js"
import style0 from "./pc-footer.vue?vue&type=style&index=0&id=6125f398&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6125f398",
  null
  
)

export default component.exports
import QSpace from 'quasar/src/components/space/QSpace.js';
import qInstall from "../../../node_modules/@quasar/app/lib/webpack/runtime.auto-import.js";
qInstall(component, 'components', {QSpace});
